module.exports = __webpack_public_path__ + "img/kabby.eba3e393.png";